import React from "react";
import {Card} from "../modules/EmployeeManagement";

export function EmployeeCardPage(props) {
  return (
    <Card {...props} />
  );
}
